import { useQuery } from '@tanstack/react-query';
import { validateCart } from '../../api/apiStorefront';
import { useAuthContext } from '../../auth/useAuthContext';

export const useValidateCart = () => {
  const { isAuthenticated } = useAuthContext();
  
  return useQuery({
    queryKey: ['cart-validation'],
    queryFn: validateCart,
    staleTime: 1000 * 60 * 2, // 2 minutes
    retry: 1,
    enabled: isAuthenticated, // Only run when authenticated
  });
};
